import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './security/firebase';
import { initAppCheck } from './security/app-check';
import App from './App.tsx';

initAppCheck();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
